import { render, staticRenderFns } from "./report-category-slug.vue?vue&type=template&id=7dc8a41e&scoped=true&"
import script from "./report-category-slug.component.ts?vue&type=script&lang=ts&"
export * from "./report-category-slug.component.ts?vue&type=script&lang=ts&"
import style0 from "./report-category-slug.vue?vue&type=style&index=0&id=7dc8a41e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8a41e",
  null
  
)

export default component.exports